import countries from 'i18n-iso-countries';

/**
 * VAT Nr required, shipping costs 30€, invoice layout: Reverse Charge (13b USTG )
 */
export const EUCountries = [
  'BE',
  'BG',
  'DK',
  'DE',
  'EE',
  'FI',
  'FR',
  'GR',
  'IE',
  'IT',
  'HR',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'AT',
  'PL',
  'PT',
  'RO',
  'SE',
  'SK',
  'SI',
  'ES',
  'CZ',
  'HU',
  'CY',
];

export const DACH = [
  'DE',
  'AT',
  'CH',
];

/**
 * VAT Nr not required, shipping costs 40€+10€, invoice layout: Reverse Charge
 */
export const NonEUEuropeanCountries = [
  'AL',
  'AD',
  'BA',
  'LI',
  'MD',
  'MC',
  'ME',
  'NO',
  'CH',
  'RS',
  'UA',
  'BY',
  'GB',
];

/**
 * VAT Nr not required, shipping costs 60€+10€, invoice layout: Reverse Charge
 */
export const OtherCountries = [
  'DZ',
  'EG',
  'IL',
  'LB',
  'LY',
  'MA',
  'RU',
  'TN',
  'TR',
  'SA',
  'KW',
  'AE',
  'KZ',
  'AR',
  'BH',
  'BR',
  'CA',
  'CN',
  'CO',
  'HK',
  'IN',
  'ID',
  'JO',
  'QA',
  'OM',
  'ZA',
  'SG',
  'TH',
  'VN',
  'CL',
  'GE',
  'AM',
];

type CountryOption = {
  viewValue: string;
  value: string;
}

export const buildCountryOptions = (locale: string, isAdmin: boolean): CountryOption[] => {
  let localizedCountries = [];
  const allCountriesObject = countries.getNames('en') as {[key: string]: string};

  if (isAdmin) {
    localizedCountries = Object.keys(allCountriesObject).map((key) => key);
  } else if (locale === 'de') {
    localizedCountries = DACH;
  } else {
    // remove Germany from the list
    delete allCountriesObject.DE;
    localizedCountries = Object.keys(allCountriesObject).map((key) => key);
  }
  return localizedCountries.map((countryCode) => ({
    viewValue: countries.getName(countryCode, locale),
    value: countryCode,
  } as CountryOption))
    .sort((current, next) => {
      const currentCountry = current.viewValue.toUpperCase();
      const nextCountry = next.viewValue.toUpperCase();
      let comparison = 0;
      if (currentCountry > nextCountry) {
        comparison = 1;
      } else if (currentCountry < nextCountry) {
        comparison = -1;
      }
      return comparison;
    });
};

export const isUserInternational = (
  instituteCountry: string,
): boolean => !DACH.includes(instituteCountry);
